import styled from "styled-components";

export const NumeroSorteado = styled.h1`
  color: ${({ theme }) => theme.color.highlight["03"]};
`;

export const NumeroSorteadoLabel = styled.p`
  color: ${({ theme }) => theme.color.neutral["03"]};
  margin-right: 32px;
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectAno = styled.select`
  margin-right: 32px;
  width: 176px;
`;

export const SelectData = styled.select`
  width: 176px;
`;

export const NumeroSorteadoContainer = styled.div`
  background-color: #f7f9fa;
  margin-bottom: 32px;
  padding: 20px 16px;
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.color.feedback.error};
`;
